<template>
    <div>
        <div v-if="template === 'simple'" class="paginationLengthSimple">
            <span>View</span>
            <form-dropdown
                id="dropdown-records-1"
                v-model="value"
                :placeholder="`Showing ${length} records`"
                :value="length"
                class="pagination-length"
            >
                <option v-for="currentValue in lengths" :key="currentValue" :value="currentValue">
                    {{ currentValue }}
                </option>
            </form-dropdown>
        </div>
        <template v-else>
            <form-dropdown
                id="dropdown-records-2"
                v-model="value"
                :placeholder="`Showing ${length} records`"
                :value="length"
                class="pagination-length"
            >
                <option v-for="currentValue in lengths" :key="currentValue" :value="currentValue">
                    Show {{ currentValue }}
                </option>
            </form-dropdown>
        </template>
    </div>
</template>

<script>
export default {
    emits: ['updateLength'],
    
    props: ['length', 'context', 'template', 'lengthsProps'],

    data() {
        return {
            lengthsDefault: [10, 25, 50, 100],
            value: this.length,
        };
    },

    computed: {
        lengths() {
            if (this.lengthsProps) {
                return this.lengthsProps;
            }

            return this.lengthsDefault;
        },
    },

    watch: {
        value(newValue, oldValue) {
            if (!this.value) return;
            if (+newValue === +oldValue) return;
            if (
                this.context === 'tags' ||
                this.context === 'contacts' ||
                this.context === 'tagContacts' ||
                this.context === 'triggers' ||
                this.context === 'broadcasts' ||
                this.context === 'keywordContacts' ||
                this.context === 'keywords'
            ) {
                this.$store.dispatch(`${this.context}CustomUpdateLengthSelector`, {
                    page: this.value,
                    data: 1,
                });
            } else if (this.context) {
                this.$store.dispatch(`${this.context}UpdatePage`, 1);
                this.$store.dispatch(`${this.context}UpdateLength`, this.value);
            } else {
                this.$emit('updateLength', this.value);
            }
        },

        length(newLength) {
            this.value = newLength;
        },
    },
};
</script>

<style>
.selectize-no-arrow .selectize-input::after {
    visibility: hidden;
}
</style>
